import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
// no logic in this factory!
/* v8 ignore start */ /**
 * Create context relevant objects to use within React.
 *
 * @param object
 * @returns
 */ function createContextFactory(object) {
    /**
     * MobX stores collection
     */ const StoreContext = /*#__PURE__*/ createContext(object);
    /**
     * MobX HOC to get the context via hook.
     *
     * @param children
     */ const StoreProvider = ({ children })=>/*#__PURE__*/ _jsx(StoreContext.Provider, {
            value: object,
            children: children
        });
    /**
     * Get all the MobX stores via a single hook.
     */ const useStores = ()=>useContext(StoreContext);
    return {
        StoreContext,
        StoreProvider,
        useStores
    };
}
export { createContextFactory };
